module.exports = __webpack_public_path__ + "img/user-tag.d2c1b516.svg";